import { render } from "./detail.vue?vue&type=template&id=0c8fa6fa&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=0c8fa6fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8fa6fa"]])

export default __exports__